/**
 * Obsługa skip linków zgodnie z dyrektywą WCAG
 */
app.service('wcagSkipLinks',function(){
	let $self, $links;

	function focusFirstElement($parent) {
		// focus tylko na interaktywnych elementach, które nie są display:none
		$parent.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:visible:not([tabindex="-1"])').eq(0).focus();
	}
	function scrollAnimate($target, offset = 0, speed = 500) {
		$('html, body').animate({
			scrollTop: $target.offset().top + offset
		}, speed);
	}
	function selectTargetAction(skipTarget) {
		switch (skipTarget) {
			case 'main-content':
				skipToContent();
				break;
			case 'main-search':
				skipToSearchBox();
				break;
			case 'main-menu':
				skipToMainMenu();
				break;
			case 'main-footer':
				skipToMainFooter();
				break;
			default:
				console.warn('Brak elementu docelowego:', skipTarget);
		}
	}

	function skipToContent() {
		const $mainContent = $('#container');
		if ($mainContent.length) {
			focusFirstElement($mainContent);
		}
	}
	function skipToMainMenu() {
		const $menu = $('#hamburger');
		if ($menu.length) {
			$menu.focus().click();
		}
	}
	function skipToSearchBox() {
		const $searchBox = $('#search-menu');
		if ($searchBox.length) {
			$searchBox.focus().trigger('keyup', { key: 'Enter'});
		}
	}
	function skipToMainFooter() {
		const $footer = $('#footer');
		scrollAnimate($footer, -80); // 80px offset dla sticky headera
		focusFirstElement($footer);
	}

	function init() {
		$self = $('#header-skip-links');
		$links = $('.skip-link', $self);

		if ($links.length > 0) {
			$links.on('click', function(e) {
				e.preventDefault();
				selectTargetAction($(this).attr('data-skip-target'));
			});
		}
	}
	return {
		init,
	};
});
